import {
  DELETE_PVS_REQUEST,
  DELETE_PVS_SUCCESS,
  DELETE_PVS_FAILURE,
  RESET_PVS_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const deletePvsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PVS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case DELETE_PVS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "PVS deleted successfully",
      };

    case DELETE_PVS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to delete PVS",
      };

    case RESET_PVS_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default deletePvsReducer;
